import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { SelectButton } from 'components/system/atoms';
import COMMON from 'constants/common';
import { themeColor } from 'constants/theme';
import React from 'react';
import { colorEffectSelectAreaType } from 'types/machineConf/colorEffectSelectAreaType';

/* ************ Style ************ */
const useStyles = makeStyles()(() => ({
  selectArea: {
    width: '296px',
    fontSize: '19px',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderRadius: '8px',
    padding: '4px 8px',
    '&.grayOut': {
      position: 'relative',
    },
  },
  buttonStyle: {
    width: '100%',
    height: '48px',
    fontSize: '19px',
    borderRadius: '8px',
    paddingLeft: '8px',
    paddingRight: '8px',
    '& div': {
      textAlign: 'left',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    },
  },
  buttonBox: {
    width: '85%',
    '&.effect': {
      position: 'relative',
    },
  },
  buttonLabel: {
    width: '15%',
  },
  colorBox: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    '&.reverse': {
      flexDirection: 'row-reverse',
    },
  },
  effectBox: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    marginTop: '4px',
    '&.reverse': {
      flexDirection: 'row-reverse',
    },
  },
  disableInputArea: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    background: 'rgb(128 128 128 / 50%)',
    borderRadius: '8px',
    zIndex: 100,
    top: '0px',
    left: '0px',
  },
  leftStyle: {
    backgroundColor: themeColor.leftLightColor,
    borderColor: themeColor.leftDarkColor,
  },
  rightStyle: {
    backgroundColor: themeColor.rightLightColor,
    borderColor: themeColor.rightDarkColor,
  },
  grandStyle: {
    backgroundColor: themeColor.grandLightColor,
    borderColor: themeColor.grandDarkColor,
  },
  borderButtonStyle: {
    borderColor: `${themeColor.grandDarkColor}`,
  },
}));

/**
 *
 * @Params
 * @returns {React.FC} - 色・効果 設定エリア
 *
 */
const ColorEffectSelectArea: React.FC<React.PropsWithChildren<colorEffectSelectAreaType>> = React.memo((props) => {
  const {
    leftRight,
    selectButtonLR,
    colorSelect,
    effectSelect,
    effectDisabled,
    disabled = false,
    isAreaGrayOut,
    isGrand,
  } = props;
  const { classes } = useStyles();
  let stationStyle = leftRight === COMMON.LEFT_RIGHT.LEFT ? classes.leftStyle : classes.rightStyle;
  const buttonStyle = `${classes.buttonStyle}`;
  if (isGrand) {
    stationStyle = classes.grandStyle;
  }
  const reverse = selectButtonLR === COMMON.LEFT_RIGHT.LEFT ? '' : 'reverse';
  const areaColor = isAreaGrayOut ? 'grayOut' : '';

  return (
    <Box className={`${classes.selectArea} ${stationStyle} ${areaColor}`}>
      <Box className={`${classes.colorBox} ${reverse}`}>
        <Box className={`${classes.buttonBox}`}>
          <SelectButton
            className={buttonStyle}
            leftRight={selectButtonLR}
            onClick={colorSelect.selectButton.onClick}
            arrowSize="28px"
            isSelected={colorSelect.selectButton.isSelected}
            disabled={disabled}
            disabledBorderColor={isGrand ? themeColor.grandDarkColor : undefined}
            style={isGrand ? classes.borderButtonStyle : undefined}>
            {colorSelect.value}
          </SelectButton>
        </Box>
        <Box className={classes.buttonLabel}>色</Box>
      </Box>
      <Box className={`${classes.effectBox} ${reverse}`}>
        <Box className={`${classes.buttonBox} effect`}>
          <SelectButton
            className={buttonStyle}
            leftRight={selectButtonLR}
            onClick={effectSelect.selectButton.onClick}
            arrowSize="28px"
            isSelected={effectSelect.selectButton.isSelected}
            disabled={effectDisabled || disabled}
            disabledBorderColor={isGrand ? themeColor.grandDarkColor : undefined}
            style={isGrand ? classes.borderButtonStyle : undefined}>
            {effectSelect.value}
          </SelectButton>
          {/* effectDisabledがtrueのときは効果を設定できないようにする */}
          {effectDisabled && <Box className={classes.disableInputArea} />}
        </Box>
        <Box className={classes.buttonLabel}>効果</Box>
      </Box>
      {/* isAreaGrayOutがtrueのときはエリアをグレーアウトする */}
      {isAreaGrayOut && <Box className={classes.disableInputArea} />}
    </Box>
  );
});

export default ColorEffectSelectArea;
